import { Component, Inject, OnInit } from '@angular/core';
import {
  CustomerUserService,
  CustomerUserSettingsInputModel,
  CustomerUserSettingsOutputModel,
} from '@cloudia-shared/apis/generated/user-api';
import { ModalController } from '@ionic/angular';
import { BaseComponent } from '@tcp/cloudia-utilities';
import { take } from 'rxjs';
import { CookieSettingsModalComponent } from '../cookie-settings-modal/cookie-settings-modal.component';

@Component({
  selector: 'cloudia-cookie-consent-modal',
  templateUrl: './cookie-consent-modal.component.html',
  styleUrls: ['./cookie-consent-modal.component.scss'],
})
export class CookieConsentModalComponent
  extends BaseComponent
  implements OnInit
{
  userSettings: CustomerUserSettingsOutputModel;
  modal: any;
  constructor(
    private readonly modalController: ModalController,
    @Inject(CustomerUserService) private readonly userApi: CustomerUserService
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadUserSettings();
  }

  async viewCookieSettings(event) {
    this.close(event).then(async () => {
      this.modal = await this.modalController.create({
        component: CookieSettingsModalComponent,
        cssClass: ['cookie-settings-popup'],
        backdropDismiss: false,
      });
      return this.modal.present();
    });
  }

  acceptAllCookies(event) {
    this.updateUserSettings();
    this.close(event, true);
  }

  async close(event, accepted?: boolean) {
    event.stopPropagation();
    await this.modalController.dismiss(accepted);
  }

  private loadUserSettings(): void {
    this.userApi
      .getUserSettings()
      .pipe(take(1))
      .subscribe((settings: CustomerUserSettingsOutputModel) => {
        this.userSettings = settings;
      });
  }

  private updateUserSettings() {
    const data: CustomerUserSettingsInputModel = {
      dateAndTimeSettings: this.userSettings?.dateAndTimeSettings
        ? this.userSettings.dateAndTimeSettings
        : { dateFormat: 'DAY_MONTH_YEAR_DOTS', timeFormat: '24_HOUR_SYSTEM' },
      cookiePreferences: {
        necessaryCookies: {
          accepted: true,
        },
        analyticalCookies: {
          accepted: true,
        },
      },
    };

    this.userApi.updateUserSettings(data).subscribe({
      next: () => {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      },
      error: (err) => {
        throw new Error(`Settings update error: ${err?.message}`);
      },
    });
  }
}
